import React from 'react'

const Paging = ({changePage, currentPage, totalPages}) => {
  return (
    <div className='text-center grid grid-cols-3 bg-white rounded-lg border text-lg text-gray-600 mx-auto mb-6 max-w-lg shadow-sm'>
        <button className='hover:bg-slate-100 p-2 rounded-s-lg text-purple-600 text-xl' onClick={() => changePage(-1)}><i className='bi bi-chevron-left'></i></button>
        <div className='p-2 bg-purple-50 border-purple-300 border'><span className='font-medium text-xl'>{currentPage}</span> <span className='text-base'>/ {totalPages}</span></div>
        <button className='hover:bg-slate-100 p-2 rounded-e-lg text-purple-600 text-xl' onClick={() => changePage(1)}><i className='bi bi-chevron-right'></i></button>
    </div>
  )
}

export default Paging